module.exports = __webpack_public_path__ + "img/h5-activity-bg.f205f183.png";